/* eslint-disable @typescript-eslint/naming-convention -- API response uses snake_case */
import { SchedulingServiceSessionType } from '@sondermind/utilities/models-scheduling';

export class TimeSlot {
  start: Date;
  end: Date;
  participants: Array<{ providerId: number; }>;
  sessionType?: SchedulingServiceSessionType;
  locationId?: number;

  constructor(json: ITimeSlotApiResponse) {
    this.start = new Date(json.start);
    this.end = new Date(json.end);
    this.participants = json.participants.map((participant) => ({
      providerId: +participant.provider_id
    }));
    // Store the session type if it is returned by scheduling-core, otherwise treat as hybrid
    this.sessionType = (json.session_type as SchedulingServiceSessionType) ?? SchedulingServiceSessionType.HYBRID;
    this.locationId = json.location_id ?? null;
  }
}

export interface ITimeSlotApiResponse {
  start: Date;
  end: Date;
  participants: Array<{ provider_id: string; }>;
  session_type?: string;
  location_id?: number;
}
